import React, { useState, useEffect, useMemo } from 'react';
import { reaction } from 'mobx';
import { CompanyLogo } from '@frontend-monorepo/cyolo-company';
import { observer } from 'mobx-react';
import { MinimalNavBarMobile, MinimalNavBar } from '@frontend-monorepo/cyolo-ui';

var key = 'logoKey';

var Logo = function Logo(_a) {
  var companyInfoStore = _a.rootStore.companyInfoStore,
      type = _a.type,
      _b = _a.style,
      style = _b === void 0 ? {} : _b,
      _c = _a.forceAdminLogo,
      forceAdminLogo = _c === void 0 ? false : _c; // support white-labeling, we dont show default icon until all data returned

  var _d = useState( /*#__PURE__*/React.createElement("div", {
    key: key
  })),
      logoElement = _d[0],
      setLogoElement = _d[1];

  useEffect(function () {
    return reaction(function () {
      return companyInfoStore.state;
    }, function (newState) {
      if (newState !== 'done') {
        return;
      }

      var _a = companyInfoStore.data,
          icon = _a.icon,
          adminConsoleLogo = _a.adminConsoleLogo; // use adminConsoleLogo only when forceAdminLogo=true

      var customLogo = forceAdminLogo ? adminConsoleLogo : icon;

      if (Boolean(customLogo)) {
        setLogoElement( /*#__PURE__*/React.createElement("img", {
          src: customLogo,
          alt: "company logo",
          key: key,
          height: 28
        }));
        return;
      } // default: cyolo company-logo


      setLogoElement( /*#__PURE__*/React.createElement(CompanyLogo, {
        type: type,
        style: style,
        key: key
      }));
    });
  }, []);
  return logoElement;
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var MOBILE_MAX_WIDTH = 750;

function useWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  var _a = useState(getSize),
      windowSize = _a[0],
      setWindowSize = _a[1];

  useEffect(function () {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}

function isMobile() {
  var width = useWindowSize().width;
  return width <= MOBILE_MAX_WIDTH;
}

var UserFacingNavbar = function UserFacingNavbar(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j;

  var _k = _a.rootStore,
      userStore = _k.userStore,
      companyInfoStore = _k.companyInfoStore,
      onOpenVaultClick = _a.onOpenVaultClick,
      onOpenMenuClick = _a.onOpenMenuClick,
      onUpdatePassword = _a.onUpdatePassword,
      onCyoloConnectClick = _a.onCyoloConnectClick,
      onAdminPortalClick = _a.onAdminPortalClick,
      onRecordingsClick = _a.onRecordingsClick,
      onSupervisorClick = _a.onSupervisorClick,
      onPersonalInfoClick = _a.onPersonalInfoClick,
      onCommandLineClick = _a.onCommandLineClick,
      _l = _a.title,
      title = _l === void 0 ? '' : _l;
  var userDropDownSections = useMemo(function () {
    var firstSection = [];

    if (onAdminPortalClick !== undefined) {
      firstSection.push({
        text: 'Admin Portal',
        onClick: onAdminPortalClick
      });
    }

    if (onRecordingsClick !== undefined) {
      firstSection.push({
        text: 'Recordings',
        onClick: onRecordingsClick
      });
    }

    if (onSupervisorClick !== undefined) {
      firstSection.push({
        text: 'Supervisor',
        onClick: onSupervisorClick
      });
    }

    var secondSection = [];

    if (onOpenVaultClick !== undefined) {
      secondSection.push({
        text: 'User Secrets',
        onClick: onOpenVaultClick
      });
    }

    if (onUpdatePassword !== undefined) {
      secondSection.push({
        text: 'Change Password',
        onClick: onUpdatePassword
      });
    }

    if (onPersonalInfoClick !== undefined) {
      secondSection.push({
        text: 'Personal Info & Security',
        onClick: onPersonalInfoClick
      });
    }

    if (onCyoloConnectClick !== undefined) {
      secondSection.push({
        text: 'Download Cyolo Connect',
        onClick: onCyoloConnectClick
      });
    }

    if (onCommandLineClick !== undefined) {
      secondSection.push({
        text: 'Download Cyolo CLI',
        onClick: onCommandLineClick
      });
    }

    var thirdSection = [{
      text: 'Logout',
      onClick: function onClick() {
        window.location.href = '/cyolo/v1/logout';
      }
    }];
    return [firstSection, secondSection, thirdSection];
  }, [onOpenVaultClick, onUpdatePassword, onCyoloConnectClick, onAdminPortalClick, onRecordingsClick, onSupervisorClick, onPersonalInfoClick]);

  if (isMobile()) {
    return /*#__PURE__*/React.createElement(MinimalNavBarMobile, {
      userName: (_b = userStore.data) === null || _b === void 0 ? void 0 : _b.name,
      userEmail: (_c = userStore.data) === null || _c === void 0 ? void 0 : _c.email,
      firstName: (_d = userStore.data) === null || _d === void 0 ? void 0 : _d.firstName,
      lastName: (_e = userStore.data) === null || _e === void 0 ? void 0 : _e.lastName,
      onMenuClick: onOpenMenuClick,
      title: title,
      userDropdownSections: userDropDownSections
    });
  }

  return /*#__PURE__*/React.createElement(MinimalNavBar, {
    logo: /*#__PURE__*/React.createElement(Logo, {
      rootStore: {
        companyInfoStore: companyInfoStore
      },
      type: "white"
    }),
    variant: "user-nav",
    userName: (_f = userStore.data) === null || _f === void 0 ? void 0 : _f.name,
    userEmail: (_g = userStore.data) === null || _g === void 0 ? void 0 : _g.email,
    firstName: (_h = userStore.data) === null || _h === void 0 ? void 0 : _h.firstName,
    lastName: (_j = userStore.data) === null || _j === void 0 ? void 0 : _j.lastName,
    userDropdownSections: userDropDownSections,
    title: title
  });
};

var UserFacingNavbar$1 = observer(UserFacingNavbar);

export { Logo, UserFacingNavbar$1 as UserFacingNavbar };
//# sourceMappingURL=index.es.js.map
